export default (function () {
  return {
    colour: {
      // Social elements
      socialGoogle: '#4285f4',
      // Google blue
      socialGoogleHover: '#3367d6',
      // Google blue hover state
      socialGooglePlus: '#db4437',
      // Google Plus red
      socialGooglePlusHover: '#c53d31',
      // Google Plus red hover state
      socialFacebook: '#3b5998',
      // Facebook blue
      socialFacebookHover: '#355089',
      // Facebook blue hover state
      socialTwitter: '#55acee',
      // Twitter blue
      socialTwitterHover: '#4c9ad6',
      // Twitter blue hover state
      socialPinterest: '#cb2027',
      // Pinterest red
      socialPinterestHover: '#b2070e',
      // Pinterest red hover
      socialLinkedin: '#007bb5',
      // Linkedin blue
      socialLinkedinHover: '#00629c',
      // Linkedin blue hover
      socialYoutube: '#b00',
      // Youtube red
      socialYoutubeHover: '#a20000',
      // Youtube red hover
      socialInstagram: '#8a3ab9',
      // Instagram purple violet
      socialInstagramHover: '#7121a0' // Instagram purple violet hover

    }
  };
});